import { getStore } from '../store/store';
import { SearchScopeKind } from 'owa-search-service/lib/data/schema/SearchScope';

/**
 * Determines whether the current search scope is set to current folder.
 * Returns true if the staticSearchScope has isCurrentFolderScope set to true.
 */
export default function getIsCurrentFolderScope(): boolean {
    const store = getStore();
    const { staticSearchScope } = store;

    // Check if any scope type has isCurrentFolderScope set to true
    return (
        (staticSearchScope?.kind === SearchScopeKind.PrimaryMailbox &&
            staticSearchScope.isCurrentFolderScope === true) ||
        (staticSearchScope?.kind === SearchScopeKind.ArchiveMailbox &&
            staticSearchScope.isCurrentFolderScope === true) ||
        (staticSearchScope?.kind === SearchScopeKind.SharedFolders &&
            staticSearchScope.isCurrentFolderScope === true)
    );
}
